@if(service.viewDroplistItems.length){
<div class='admissions-manager-views-part'>

	@if(service.selectedViewItem(); as selectedViewItem){

	<droplist class="views-droplist" [items]='service.viewDroplistItems' [selectedItem]='selectedViewItem'
		(selectionChange)='service.onViewDroplistChange($event)' [filterable]='false' [navigation]='true'
		sortBy='customSort' style='display:inline-block'>
	</droplist>
	@switch (selectedViewItem.uniqueId) {
	@case (service.viewId.Status) {
	<admissions-manager-status-view-part></admissions-manager-status-view-part>
	}
	@case (service.viewId.ApplStatusFlow) {
	<admissions-manager-sankey-flow-view-part></admissions-manager-sankey-flow-view-part>
	}
	@case (service.viewId.TrimesterSwitchover) {
	<admissions-manager-trimester-switchover-view-part></admissions-manager-trimester-switchover-view-part>
	}
	}
	}

</div>
}